import styled from 'styled-components';

export const EstimatedTextInCartStyled = styled.div<{ isMobile?: boolean }>`
  .demo_estimated_text_cart {
    user-select: none;
    display: flex;
    background-color: #f2f2f2;
    padding: 1rem;
    .demo-content {
      padding-left: 1rem;
      width: 100%;
    }
    .demo-title {
      display: flex;
      justify-content: space-between;
    }
    .demo-text {
      font-size: 1rem;
      color: #bababa;
    }
    .demo-image {
      max-height: 100px;
      border-radius: 1rem;
    }
    .demo-button {
      color: #bababa;
      background-color: white;
      padding: 0.25rem 0.5rem 0.25rem 0.5rem;
      border-radius: 1rem;
      cursor: default;
    }
    margin-bottom: 0.5rem;
  }

  @media (max-width: 425px) {
    .demo_estimated_text_cart {
      padding-left: 0;
      padding-right: 0;
    }
    .demo_content {
      padding: 0;
    }
    .demo-image {
      display: none;
    }
    .demo-button {
      display: none;
    }
  }
  .text-field-custom {
    & > div:first-child {
      width: 100%;
    }
  }
  .btn-add-variable {
    & button.Polaris-Button {
      height: ${(props) => (props.isMobile ? '36px' : '32px')};
    }
  }
`;
